import { QueryDto } from '../../../generated/model/models';

export enum QueryListContextActionTypes {
  UpdateCheckedQueryList = 'queryList/UPDATE_QUERY_LIST',
}

export type QueryListContextActions = {
  type: QueryListContextActionTypes.UpdateCheckedQueryList;
  payload: QueryDto[];
};

export type QueryListContextProps = {
  checkedQueryList: QueryDto[];
};

export type QueryListProviderProps = { children: React.ReactNode };
